import React from "react";
import UnifiedDocument from "../salesInvoice/UnifiedDocument";
import { DOCUMENT_TYPES } from "../config/DocumentConfig";

const SalesReturn = () => {
  return <UnifiedDocument documentType={DOCUMENT_TYPES.SALES_RETURN} />;
};

export default SalesReturn;
